export var GenericVisualSubType;
(function (GenericVisualSubType) {
    GenericVisualSubType["AreaLine"] = "area_line";
    GenericVisualSubType["AreaLineStacked"] = "area_line_stacked";
    GenericVisualSubType["AreaSmoothLine"] = "area_smooth_line";
    GenericVisualSubType["AreaSmoothLineStacked"] = "area_smooth_line_stacked";
    GenericVisualSubType["AreaStepLine"] = "area_step_line";
    GenericVisualSubType["AreaStepLineStacked"] = "area_step_line_stacked";
    GenericVisualSubType["Bar"] = "bar";
    GenericVisualSubType["BarStacked"] = "bar_stacked";
    GenericVisualSubType["Column"] = "column";
    GenericVisualSubType["ColumnStacked"] = "column_stacked";
    GenericVisualSubType["Generic"] = "generic";
    GenericVisualSubType["Line"] = "line";
    GenericVisualSubType["Radar"] = "radar";
    GenericVisualSubType["Scatter"] = "scatter";
    GenericVisualSubType["SmoothLine"] = "smooth_line";
    GenericVisualSubType["StepLine"] = "step_line";
    GenericVisualSubType["Waterfall"] = "waterfall";
})(GenericVisualSubType || (GenericVisualSubType = {}));
//# sourceMappingURL=genericVisualSubType.js.map